import { v4 as uuidv4 } from "uuid";
export class AssetManagerModel {
    constructor() {
        this.id = uuidv4();
        this.assetTypeId = "";
        this.assetType = "";
        this.assetCode = "";
        this.name = "";
        this.assetCategory = "";
        this.assetStatusTypeId = "";
        this.assetStatus = "";
        this.employeeId = "";
        this.employeeName = "";
        this.teamName = "";
        this.searchByAssetName = "";
        this.searchByAssetStatus = "";
        this.searchByAssetType = "";
        this.configurationString = "";
        this.assetLocationName = "";
    }
}
export default class AssetManager extends AssetManagerModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
